import React, { useState } from 'react';
import { FormattedMessage } from 'react-intl';
import {
  PermissionsArrayClubLevel,
  PermissionsArrayPeakLevel,
} from 'modules/permissions/constants';
import { PermissionLevels } from 'common/constants/permissions';
import { IPolicyListItem } from 'modules/permissions/interfaces/permissions';
import commonMessages from 'common/messages/messages';
import { DialogComponent, LoadingBackdrop } from 'common/components';
import { CollapsedComponent } from '..';
import { getPermissionsFilteredArray } from 'modules/permissions/utils/permission';
import { useGetPolicyItem } from 'api/policy.api';

interface ViewPolicyModalProps {
  selectedRow: IPolicyListItem;
  onClose: () => void;
}

export default function ViewPolicyModal({
  selectedRow,
  onClose,
}: ViewPolicyModalProps): JSX.Element {
  const [hideUnchecked, setHideUnchecked] = useState(true);

  const { data: policyItem, isLoading } = useGetPolicyItem(selectedRow.id);

  let policyLevel = PermissionLevels.CORPORATE;

  if (policyItem && PermissionsArrayClubLevel[policyItem.permissionGroup]) {
    policyLevel = PermissionLevels.CLIENT;
  }

  if (policyItem && PermissionsArrayPeakLevel[policyItem.permissionGroup]) {
    policyLevel = PermissionLevels.PEAK;
  }

  const permissionsArray = policyItem
    ? getPermissionsFilteredArray(policyLevel, hideUnchecked, [policyItem?.permissionGroup])
    : [];

  return (
    <DialogComponent
      title={selectedRow?.title}
      submitBtnTitle={<FormattedMessage {...commonMessages.closeBtn} />}
      size="sm"
      isOpen
      onClose={onClose}
      disableFullScreenBehavior
      submitBtn={false}
      cancelBtnTitle={<FormattedMessage {...commonMessages.closeBtn} />}
    >
      <LoadingBackdrop isLoading={isLoading} />
      {!isLoading && (
        <CollapsedComponent
          permissions={permissionsArray}
          permissionSet={policyItem?.permissionSet || []}
          onHideUnchecked={setHideUnchecked}
          hideUnchecked={hideUnchecked}
        />
      )}
    </DialogComponent>
  );
}
